module.exports = __webpack_public_path__ + "static/storefire-f480bad0607362ba09ccafccb7fb82de.jpg";